import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { Star } from "lucide-react";

export default function Reviews() {
  const { user } = useAuth();
  const [reviews, setReviews] = useState([]);
  useEffect(() => { api.get("/reviews").then((r) => setReviews(r.data)); }, []);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="reviews-page">
      <Header />
      <div className="flex pt-16">
        <Sidebar />
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <div className="text-[11px] uppercase tracking-widest font-bold text-orange-600">Mes avis</div>
          <h1 className="font-display font-extrabold text-3xl text-slate-900 tracking-tight">Notation clients</h1>

          <div className="mt-6 grid sm:grid-cols-2 gap-4" data-testid="reviews-grid">
            {reviews.length === 0 && <div className="col-span-2 p-8 bg-white border border-slate-200 rounded-md text-center text-slate-500 text-sm">Aucun avis pour le moment.</div>}
            {reviews.map((r) => (
              <div key={r.review_id} className="bg-white border border-slate-200 rounded-md p-5">
                <div className="flex items-center gap-1 text-amber-500 mb-2">
                  {[1,2,3,4,5].map((n) => <Star key={n} className={`h-4 w-4 ${n <= r.rating ? "fill-amber-500" : "text-slate-300"}`} />)}
                  <span className="text-xs text-slate-500 ml-1">{new Date(r.created_at).toLocaleDateString("fr-FR")}</span>
                </div>
                <div className="font-display font-bold text-slate-900">{r.client_name || "Client"}</div>
                <p className="mt-2 text-sm text-slate-700 whitespace-pre-wrap">{r.comment || "—"}</p>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
